// IconButton used for buttons like 'Clear Room'
import React from "react";
import { FaTrashAlt } from 'react-icons/fa';


export default class IconButton extends React.Component {
    constructor ( props ) {
        super( props );
    }
	

    render () {
        // console.log("HAS OBJECTS:");
        // console.log(this.props.hasObjects);

        return (
            <div className={this.props.hasObjects ? "iconbutton trash-icon-button box-shadow-border" : "iconbutton iconbutton-disabled trash-icon-button box-shadow-border"} onClick={this.props.hasObjects ? this.props.clearPlacedObjects : null}>
                <FaTrashAlt />
            </div>
        );
    }
}